<template>

    <v-row justify="start">
      <v-dialog v-model="dialog" fullscreen hide-overlay scrollable transition="dialog-bottom-transition" class="pa-0 ma-0" style="z-index:10000000000;">
        <v-card flat>
          <v-card-title>
            <span>Preview Ansicht</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false" color="black">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-img :src="dialogImage" contain max-height="100%" @click="dialog = false"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="dialogImageisVertical" @click="download(offerImageUrlV, 'offer' + offerId + 'v.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
            <v-btn v-else @click="download(offerImageUrlH,'offer' + offerId + 'h.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-col cols="12" xs="12" sm="10" md="6" class="pb-0">
      <p class="headline font-weight-light">Templates</p>
    </v-col>
    <v-col cols="12" xs="12">
    <v-tabs
            v-model="tab"
            background-color="#EEEEEE"
            color="black"
            grow
    >
      <v-tab>Template</v-tab>
      <v-tab>Preview</v-tab>
      <v-tab>Dateien</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
          <div :id="uploadCenterName" class="staging">
            <form>
              <input ref="iUploadTemplate" type="file" style="position: absolute;left:-1000px;">
            </form>
          </div>
          <!--<v-form class="pa-4">-->
              <v-row class="pa-4">
                <v-col cols="6" class="py-0">
                  <v-text-field
                  label="Name"
                  clearable
                  outlined
                  v-model="formData.name"
                  dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" class="py-0">
                  <v-text-field
                  label="Kommentar"
                  clearable
                  outlined
                  v-model="formData.comment"
                  dense
                  ></v-text-field>
                </v-col>
                <v-col>
                        <span class="text-none body-2" style="color:#080808" @click='onPickFile'>
                          Hier können Sie Template Dateien hochladen.<v-icon color="#00838f">cloud_upload</v-icon>
                        </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="6" sm="6"  class="py-0">
                  <v-textarea
                      label="Konfiguration"
                      clearable
                      auto-grow
                      outlined
                      v-model="formData.config"
                      dense
                  ></v-textarea>
                </v-col>
                <v-col cols="12" xs="6" sm="6" class="py-0 text-right">
                  <v-btn @click.stop="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
                  </v-btn>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-btn @click.stop="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
                </v-col>
                <v-col cols="6" class="py-0 text-right">
                  <v-btn @click.stop="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
                  </v-btn>
                </v-col>
              </v-row>
          <!--</v-form>-->
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12" xs="6" md="4" class="">
            <v-text-field
                label="Advisory Id"
                clearable
                outlined
                v-model="advisoryId"
                dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="6" md="4" class="">
            <v-text-field
                label="Offer Id"
                clearable
                outlined
                v-model="offerId"
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" md="4" class="">
            <v-btn @click="updatePreview()" color="green" class="text-none" outlined elevation="3">Update preview</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="6" md="4" class="">
            <v-text-field
                label="Office Id"
                clearable
                outlined
                v-model="officeID"
                dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="6" md="4" class="">
            <v-text-field
                label="Session Id"
                clearable
                outlined
                v-model="sessionID"
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="6" md="4" class="">
            <v-btn @click="openLink()" color="green" class="text-none" outlined elevation="3">Open Bosys Link</v-btn>
          </v-col>
        </v-row>
        <v-row>
        </v-row>
        <v-row>
        <v-col cols="12" xs="6" md="6">
          <v-img :src="offerImageUrlH" max-height="240" max-width="320" @click="preview(true,offerImageUrlH)"></v-img>
        </v-col>
        <v-col cols="12" xs="6" md="6">
          <v-img :src="offerImageUrlV" max-height="320" max-width="160" @click="preview(true,offerImageUrlV)"></v-img>
        </v-col>
          <v-col cols="12" xs="12" sm="12" v-if="errors && errors.length > 0">
            <v-textarea v-model="errors"></v-textarea>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col cols="12" xs="12" sm="12" class="">
            <v-data-table
                :headers="headerFiles"
                :items="files"
                hide-default-footer
                :items-per-page='-1'
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

// import swal from 'sweetalert2'

export default {
  name: 'TemplateDefault',
  components: {},
  data () {
    return {
      dialog: false,
      dialogImage: null,
      dialogImageisVertical: false,
      advisoryId: "NYZN-0275",
      offerId: "167486752",
      sessionID: 'max918jvafrsdsm#62a(h1baq',
      officeID: '050025001',
      code: "0815",
      statusList: [
        {
          key: 0,
          title: 'Nein'
        },
        {
          key: 1,
          title: 'Ja'
        }
      ],
      companyGuid: '',
      guid: 0,
      tab: 0,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      progress: 100,
      uploadCenterName: 'uploadCenter',
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      },
      till: null,
      files: [],
      activeFrom: new Date().getTime(),
      activeTill: new Date().getTime(),
      offerImageUrlH: null,
      errors: '',
      offerImageUrlV: null,
      headerFiles: [{
        name: 'Name',
        value: 'name'
      }]
    }
  },
  methods: {
    onGetData: function (data) {
      this.errors = ''
      this.formData = data
    },
    onGetFiles: function (data) {
      this.errors = ''
      this.files = data
    },
    onItemUpdated: function () {
      // this.cancelItem()
    },
    preview: function (isVertical, url) {
      this.dialogImageisVertical = isVertical
      this.dialogImage = url
      this.dialog = true
      console.log('url', url);
    },
    cancelItem: function () {
      if (this.companyGuid) {
        this.$router.push('/Netzwerke/' + this.companyGuid + '/2')
      } else {
        this.$router.push('/Dashboard/Templates')
      }
    },
    onGetImages: function (response) {
      this.agencyId = response.agencyId
      this.till = response.till
      this.errors = '' + response.errorH + response.error
      if (response.imageV) {
        this.offerImageUrlV = Vue.prototype.$config.HOST + "" + response.imageV.replaceAll('public', '') + "?time=" + new Date().getTime()
      }
      if (response.imageH) {
        this.offerImageUrlH = Vue.prototype.$config.HOST + "" + response.imageH.replaceAll('public', '') + "?time=" + new Date().getTime()
      }
      this.showStage = true
    },
    onGetPrepareLogin: function () {
      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        offerId: this.offerId,
        templateGuid: this.guid,
        isChannel: false,
        code: this.code
      }, this.onGetImages)
    },
    openLink: function () {
      const oid = window.encodeURIComponent(btoa(this.officeID))
      const sid = window.encodeURIComponent(btoa(this.sessionID))
      let host = 'http://192.168.5.249:8080/'
      if (host.indexOf('ds.kermax') > - 1) {
        host = 'https://ds.kermax.tv/'
      }
      console.log(location.host, host, oid, sid)
      const url = host + '#/bs/addImage?officeID=' + oid + '&sessionID=' + sid
      window.open(url, '_new')
    },
    updatePreview: function () {
      Vue.prototype.$apiPaxConnect.prepareLogin({
        advisoryId: this.advisoryId,
        templateGuid: this.guid,
        offerId: this.offerId,
        code: this.code
      }, this.onGetPrepareLogin, this.onFailedCode)
    },
    updateItem: function () {
      Vue.prototype.$apiTemplate.update(this.guid, this.formData, this.onItemUpdated)
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      Vue.prototype.$eventHub.$emit('OnProgress', percent)
      this.progress = percent
    },
    onPickFile() {
      this.$refs.iUploadTemplate.click()
    },
    onUploadSuccess(id, data) {
      console.log('upload done', id, data)
      if (data && data.success) {
        this.itemAdded = true
      }
      Vue.prototype.$apiTemplate.getFiles(this.guid, this.onGetFiles)

      Vue.prototype.$eventHub.$emit('OnProgress', 100)
    },
    initializeUpload() {
      this.uploadCenterName = 'uploadCenter' + new Date().getTime()
      this.uploadConfig.jQueryDivName = '#' + this.uploadCenterName
      this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/templates/upload/' + this.guid
      this.uploadConfig.onUploadProgress = this.onUploadProgress
      this.uploadConfig.onUploadSuccess = this.onUploadSuccess
      this.initDD()
    },
    initDD: function () {
      if (window.jQuery(this.uploadConfig.jQueryDivName).length === 0) {
        window.setTimeout(this.initDD, 1000)
      } else {
        this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
      }
    },
    initDragAndDrop(config, eventHub) {
      console.log('init drag and drop', config, window.jQuery(config.jQueryDivName))
      config.eventHub = eventHub
      config.uploadErrorMessage = ''
      this.ddConfig = config
      const cmp = this
      window.jQuery(config.jQueryDivName).dmUploader({
        url: function () {
          return cmp.ddConfig.uploadUrl
        },
        fileName: 'files',
        dataType: 'json',
        headers: {},
        allowedTypes: '*',
        maxFileSize: 64 * 1024 * 1024,
        onInit: function () {
          console.log('onInit uploader')
        },
        onBeforeUpload: function (id) {
          // updateFileStatus(id, 'uploading', 'Uploading...')
          console.log(id)
          config.eventHub.$emit('lockScreen')
        },
        onNewFile: function (id, file) {
          config.eventHub.$emit('unlockScreen')
          console.log(id, file)
        },
        onComplete: function () {
          console.log('upload complete')
          config.eventHub.$emit('unlockScreen')
        },
        onUploadProgress: function (id, percent) {
          if (config.onUploadProgress) config.onUploadProgress(id, percent)
        },
        onUploadSuccess: function (id, data) {
          if (config.onUploadSuccess) config.onUploadSuccess(id, data)
          cmp.$eventHub.$emit('unlockScreen')
        },
        onUploadError: function (id, message) {
          cmp.$eventHub.$emit('unlockScreen')
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: config.uploadErrorMessage + '(' + message + ')'
          })
        },
        onFileTypeError: function (file) {
          console.log('file', file)
        },
        onFileSizeError: function (file) {
          console.log('file', file)
        },
        onFileExtError: function (file) {
          console.log('file', file)
        },
        onFallbackMode: function (message) {
          cmp.$refs.dlgDefault.open({
            title: 'Upload Fehler',
            description: message + config.uploadErrorMessage
          })
        }
      })
    }
  },
  mounted () {
    this.guid = this.$route.params.guid
    this.companyGuid = this.$route.params.companyId
    Vue.prototype.$apiTemplate.loadById(this.guid, this.onGetData)
    this.initializeUpload()
    Vue.prototype.$apiTemplate.getFiles(this.guid, this.onGetFiles)
  }
}
</script>

<style scoped>

</style>
